export default __webpack_public_path__ + "static/media/azure-container-registry.83baebc9.svg";